import Mock from 'mockjs'
const { Random } = Mock

// 登录用户信息
export const LoginUserData = {
  customerName: Random.name(), // 客户名称
  customerPhone: Random.phone(), // 客户电话
  token: Random.name() + Random.id(), // token
}
